(function () {
  'use strict';
  if (previewMode) {
    const $popupPreview = $('#popup-preview');
    const $popupContent = $popupPreview.find('.custom-popup-wrp');

    // Desativa as transições
    $popupPreview.css('transition-duration', 0);
    $popupPreview.find('.modal-wrapper').css('transition-duration', 0);

    // Monta o popup e exibe
    function drawPopup() {
      const ppu = $popupPreview.data('preview') || {};
      //console.log(ppu);
      if (!ppu || Object.keys(ppu).length === 0) {
        modalClose('popup-preview');
        return false;
      }

      // Reseta
      $popupPreview.removeClass(
        'image-full image-hidden image-left image-right image-top img-desktop-hide img-mobile-hide content-hidden modal-force bg-blur',
      );
      $popupContent.html('');

      // Classes root
      const ppuPreventClose = ppu['prevent-close'] == '1' ? 'modal-force' : '';
      const ppuBgBlur = ppu['bg-blur'] == '1' ? 'bg-blur' : '';
      const ppuImgDesktopHide = ppu['img-desktop-hide'] == '1' ? 'img-desktop-hide' : '';
      const ppuImgMobileHide = ppu['img-mobile-hide'] == '1' ? 'img-mobile-hide' : '';
      const ppuContentHide = ppu['img-pos'] == 'full';
      const ppuContentHideClass = ppuContentHide ? 'content-hidden' : '';
      $popupPreview.addClass(ppuPreventClose);
      $popupPreview.addClass(ppuBgBlur);
      $popupPreview.addClass('image-' + ppu['img-pos']);
      if (ppuImgDesktopHide != '') {
        $popupPreview.addClass(ppuImgDesktopHide);
      }
      if (ppuImgMobileHide != '') {
        $popupPreview.addClass(ppuImgMobileHide);
      }
      if (ppuContentHideClass != '') {
        $popupPreview.addClass(ppuContentHideClass);
      }

      // Estilo (CSS)
      $popupPreview[0].style.setProperty('--ct-title-color', ppu['ct-title-color']);
      $popupPreview[0].style.setProperty('--ct-text-color', ppu['ct-text-color']);

      // Imagem
      let $imgEl = '';
      if (!ppuContentHide) {
        $imgEl = `<a href="${ppu['img-url']}" class="custom-popup-img"><img src="${ppu['img-src']}" alt="${ppu['img-alt']}" /></a>`;
      } else {
        $imgEl = `<a href="${ppu['img-url']}" class="custom-popup-img-full"><img src="${ppu['img-src']}" alt="${ppu['img-alt']}" /></a>`;
      }

      // Título
      const $ppuTitle = ppu['ct-title']
        ? `<div class="custom-popup-title">${mdParse(ppu['ct-title'], true)}</div>`
        : '';

      // Texto
      const $ppuText = ppu['ct-text'] ? `<div class="md-text custom-popup-text">${mdParse(ppu['ct-text'])}</div>` : '';

      // Formulário
      const ppuInputNameLblShowClass = ppu['input-name-label-show'] != '1' ? 'd-none' : '';
      const ppuInputEmailLblShowClass = ppu['input-email-label-show'] != '1' ? 'd-none' : '';
      const ppuInputPhoneLblShowClass = ppu['input-phone-label-show'] != '1' ? 'd-none' : '';

      // Campo (Nome)
      const $inputName =
        ppu['input-name-show'] == '1'
          ? `
      <div class="form-group">
        <label class="form-label ${ppuInputNameLblShowClass}">${ppu['input-name-label']}</label>
        <input type="text" class="form-input" name="name" maxlength="100" placeholder="${ppu['input-name-placeholder']}">
      </div>`
          : '';

      // Campo (E-mail)
      const $inputEmail =
        ppu['input-email-show'] == '1'
          ? `
      <div class="form-group">
        <label class="form-label ${ppuInputEmailLblShowClass}">${ppu['input-email-label']}</label>
        <input type="email" class="form-input" name="email" maxlength="100" placeholder="${ppu['input-email-placeholder']}">
      </div>`
          : '';

      // Campo (Telefone)
      const $inputPhone =
        ppu['input-phone-show'] == '1'
          ? `
      <div class="form-group">
        <label class="form-label ${ppuInputPhoneLblShowClass}">${ppu['input-phone-label']}</label>
        <input type="tel" class="form-input phone" name="phone" maxlength="100" placeholder="${ppu['input-phone-placeholder']}">
      </div>`
          : '';

      // Campos wrp
      const $formInputs =
        ppu['form-show'] == '1'
          ? `<div class="custom-popup-form-inputs">
        ${$inputName}
        ${$inputEmail}
        ${$inputPhone}
      </div>`
          : '';

      // Botão 1
      const $btn1 =
        ppu['btn1-show'] == '1' ? `<a herf="#" class="btn ${ppu['btn1-class']}">${ppu['btn1-txt']}</a>` : '';

      // Botão 2
      const $btn2 =
        ppu['btn2-show'] == '1' ? `<a herf="#" class="btn ${ppu['btn2-class']}">${ppu['btn2-txt']}</a>` : '';

      // Botões
      const $btnsWrp =
        $btn1 || $btn2
          ? `<div class="custom-popup-btns">
        ${$btn1}
        ${$btn2}
      </div>`
          : '';

      // Texto de fechamento
      const $closeAct = ppu['close-txt-act']
        ? `<div class="md-text close-txt-act"><a href="#">${mdParse(ppu['close-txt-act'], true)}</a></div>`
        : '';

      // Conteúdo base
      $popupContent.html(`
        ${$imgEl}
        <div class="custom-popup-content ${ppu['content-align']}">
          ${$ppuTitle}
          ${$ppuText}
          <form action="#" method="post" class="custom-popup-form">
            ${$formInputs}
            ${$btnsWrp}
          </form>
          ${$closeAct}
        </div>
      `);

      modalOpen('popup-preview');
    }

    $popupPreview.on('draw-popup', function () {
      drawPopup();
    });
  }
})();
